import { DEV } from 'cc/env';
import { _decorator, ProgressBar, Enum } from 'cc';
import OrientedComponent, { OrientedBaseProperty } from './OrientedComponent';

const { ccclass, property, menu, requireComponent } = _decorator;

@ccclass('OrientedProgressBarProperties')
class OrientedProgressBarProperties extends OrientedBaseProperty {
    @property({ tooltip: DEV && '旋轉為該方向時，是否該依據設定調整顯示樣式，節點上必需有ProgressBar的組件才會生效' })
    public updateDisplayMode: boolean = false;
    @property({
        type: Enum(ProgressBar.Mode),
        tooltip: DEV && '顯示樣式設定',
        visible(this: OrientedProgressBarProperties) {
            return this.updateDisplayMode;
        },
    })
    public mode = ProgressBar.Mode.HORIZONTAL;

    @property({ tooltip: DEV && '旋轉為該方向時，是否該依據設定調整進度條長度，節點上必需有ProgressBar的組件才會生效' })
    public updateTotalLength: boolean = false;
    @property({
        tooltip: DEV && '總長度設定',
        visible(this: OrientedProgressBarProperties) {
            return this.updateTotalLength;
        },
    })
    public totalLength: number = 0;

    @property({ tooltip: DEV && '旋轉為該方向時，是否該依據設定調整進度條移動方向，節點上必需有ProgressBar的組件才會生效' })
    public updateReverse: boolean = false;
    @property({
        tooltip: DEV && '移動方向設定',
        visible(this: OrientedProgressBarProperties) {
            return this.updateReverse;
        },
    })
    public reverse: boolean = false;
}

@ccclass('OrientedProgressBar')
@requireComponent(ProgressBar)
@menu('Orientation/OrientedProgressBar')
export default class OrientedProgressBar extends OrientedComponent<ProgressBar> {
    @property({ type: OrientedProgressBarProperties, group: '橫式' })
    public readonly landscapeProperties: OrientedProgressBarProperties = new OrientedProgressBarProperties();
    @property({ type: OrientedProgressBarProperties, group: '直式' })
    public readonly portraitProperties: OrientedProgressBarProperties = new OrientedProgressBarProperties();

    protected updateOrientationProperties(properties: OrientedProgressBarProperties) {
        if (properties.updateDisplayMode) {
            this.target.mode = properties.mode;
        }
        if (properties.updateTotalLength) {
            this.target.totalLength = properties.totalLength;
        }
        if (properties.updateReverse) {
            this.target.reverse = properties.reverse;
        }
    }

    protected getTarget() {
        return this.getComponent(ProgressBar);
    }
}
